import Vue from 'vue'
import VueRouter from 'vue-router'
import About from '../components/about'
import CadastroDB from '../components/cadastrodb/index'
import ConsultaApi from '../components/consultaapi'
import Credentials from '../components/credentials/index'
import EmailServer from '../components/emailserver/index'
import FromTo from '../components/fromto/index'
import JobEnviaDadosWsRest from '../components/jobenviadadoswsrest/index'
import JobEnviaDadosWsSoap from '../components/jobenviadadoswssoap/index'
import Parameter from '../components/parameter/index'
import RestToSoap from '../components/resttosoap/index'
// import NewsLetter from '../components/newsletter/NewsLetter.vue'
import Client from '../components/client/index'
import Dashboard from '../components/dashboard/dashboard'
import Login from '../components/login/login'
import Logout from '../components/logout/logout'
import { MonitoringLegacy, MonitoringLegacyRoutes } from '../components/monitoring-legacy/module'
import SelectClient from '../components/selectClient/selectClient'
import User from '../components/user/index'
import Workflow from '../components/workflow/index'
// import SocketServer from '../components/socketserver/Index'
import { MonitoringCockpit, MonitoringCockpitRoutes } from '../components/monitoring-cockpit/module'
import Sequence from '../components/sequence'
import Truststore from '../components/truststore/index'
import guard from './guard'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'keywords.about',
    component: About
  },
  /* {
    path: '/newsletter',
    name: 'keywords.newsletter',
    component: NewsLetter
  }, */
  {
    path: '/consulta-apis',
    name: 'keywords.api_query',
    component: ConsultaApi
  },
  {
    path: '/cadastro-db',
    name: 'keywords.db_register',
    component: CadastroDB
  },
  {
    path: '/job-envia-dados-soap',
    name: 'keywords.send_data.soap',
    component: JobEnviaDadosWsSoap
  },
  {
    path: '/job-envia-dados-rest',
    name: 'keywords.send_data.rest',
    component: JobEnviaDadosWsRest
  },
  {
    path: '/rest-to-soap',
    name: 'keywords.rest_to_soap',
    component: RestToSoap
  },
  {
    path: '/credentials',
    name: 'keywords.credentials',
    component: Credentials
  },
  {
    path: '/from-to',
    name: 'keywords.from_to',
    component: FromTo
  },
  {
    path: '/parameter',
    name: 'keywords.params',
    component: Parameter
  },
  {
    path: '/workflow',
    name: 'keywords.workflow',
    component: Workflow
  },
  {
    path: '/emailserver',
    name: 'keywords.server.email',
    component: EmailServer
  },
  {
    path: '/monitoring-legacy',
    name: 'Monitoramento Legado',
    component: MonitoringLegacy,
    children: MonitoringLegacyRoutes
  },
  {
    path: '/monitoring-cockpit',
    name: 'Monitoramento Cockpit',
    redirect: 'monitoring-cockpit/integrations',
    component: MonitoringCockpit,
    children: MonitoringCockpitRoutes
  },
  {
    path: '/client',
    name: 'keywords.clients',
    component: Client
  },
  {
    path: '/user',
    name: 'keywords.users',
    component: User
  },
  {
    path: '/dashboard',
    name: 'keywords.dashboard',
    component: Dashboard
  },
  {
    path: '/login',
    name: 'keywords.login',
    component: Login
  },
  {
    path: '/logout',
    name: 'keywords.logout',
    component: Logout
  },
  {
    path: '/select-client',
    name: 'keywords.select_client',
    component: SelectClient,
    props: route => ({ listFrom: route.query.from })
  },
  {
    path: '/sequence',
    name: 'keywords.sequences',
    component: Sequence
  },
  /* {
    path: '/socket-server',
    name: 'keywords.server.socket',
    component: SocketServer
  }, */
  {
    path: '/truststore',
    name: 'Truststore',
    component: Truststore
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Guard
router.beforeEach(guard)

export default router
